import { render } from "./last-evaluation.vue?vue&type=template&id=772f8f9e"
import script from "./last-evaluation.vue?vue&type=script&lang=js"
export * from "./last-evaluation.vue?vue&type=script&lang=js"

import "./last-evaluation.vue?vue&type=style&index=0&id=772f8f9e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__